import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { CalendarCheck } from "@phosphor-icons/react";
import { workshops as workshopsApi } from "@/api";

const STATUS_LABELS = {
  pending: "En attente",
  coming: "Oui — vient",
  not_coming: "Non — ne vient pas",

};

const ATTENDANCE_LABELS = { present: "Présent", absent: "Absent" };

function formatDate(value) {
  if (!value) return "";
  const [year, month, day] = String(value).slice(0, 10).split("-").map(Number);
  if (!year || !month || !day) return "";
  return new Date(year, month - 1, day).toLocaleDateString("fr-FR");
}

export default function ContactWorkshopsPanel({ contactId }) {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    let cancelled = false;
    async function load() {
      setLoading(true);
      setError("");
      try {
        const result = await workshopsApi.forContact(contactId);
        if (!cancelled) setItems(Array.isArray(result) ? result : []);
      } catch {
        if (!cancelled) setError("Impossible de charger les workshops.");
      } finally {
        if (!cancelled) setLoading(false);
      }
    }
    if (contactId) load();
    return () => { cancelled = true; };
  }, [contactId]);

  return (
    <section className="au-card overflow-hidden" data-testid="contact-workshops-panel">
      <div className="border-b border-[var(--do-border)] px-4 py-4 sm:px-5">
        <div className="label-eyebrow">Workshops</div>
        <h2 className="mt-1 font-heading text-xl font-black text-[var(--do-ink)]">Historique des invitations</h2>
      </div>
      {loading && <div className="p-6 text-sm text-[var(--do-muted)]">Chargement…</div>}
      {!loading && error && <div className="p-6 text-sm font-semibold text-[var(--do-accent)]">{error}</div>}
      {!loading && !error && items.length === 0 && (
        <div className="p-8 text-center">
          <CalendarCheck size={28} weight="duotone" className="mx-auto text-[var(--do-muted)]" />
          <p className="mt-3 text-sm font-semibold text-[var(--do-muted)]">Ce contact n’a encore été invité à aucun workshop.</p>
        </div>
      )}
      {!loading && !error && items.length > 0 && (
        <div className="divide-y divide-[var(--do-border)]">
          {items.map((item) => (
            <Link key={item.id} to={`/app/commerce/workshops/${encodeURIComponent(item.id)}`} className="flex flex-col gap-2 px-4 py-4 transition hover:bg-[var(--do-bg-2)]/50 sm:flex-row sm:items-center sm:justify-between sm:px-5">
              <div>
                <div className="font-heading text-sm font-black text-[var(--do-ink)]">{item.title}</div>
                <div className="mt-1 text-xs text-[var(--do-muted)]">{formatDate(item.eventDate)} · Invitation : {STATUS_LABELS[item.status] || item.status} · Présence : {ATTENDANCE_LABELS[item.attendanceStatus] || "Non renseignée"}</div>
              </div>
              <span className="text-xs font-black text-[var(--do-accent)]">Voir</span>
            </Link>
          ))}
        </div>
      )}
    </section>
  );
}
